export default "__VITE_ASSET__S4$Px4dx__"